import { route } from './route';

export const openRoutes = {
    terms: () => route('/(open)/terms'),
    privacyPolicy: () => route('/(open)/privacypolicy')
};
